import React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Header, Segment, Table } from 'semantic-ui-react'
import AvgFeed from './AvgFeed'
import { HERD_GROUP_ERROR_CLASS } from '../../../constants'

interface Props {
  herdIndex: number
}

const AvgFeeds:React.FC<Props> = ({ herdIndex }) => {
  const { t } = useTranslation()
  const { control, getValues } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `herdGroups[${herdIndex}].feeds`,
    keyName: 'key'
  })

  return (
    <>
      <Header attached='top' block>
        {t('Average Feeds')}
      </Header>
      <Segment attached style={{ overflow: 'visible' }}>
        <Table celled>
          <colgroup>
            <col style={{ width: '30%' }} />
            <col style={{ width: '30%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
          </colgroup>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('Feed component')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Region')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Percentage')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {fields.map((field, feedIndex) => (
              <AvgFeed
                key={field.key}
                id={field.key}
                index={feedIndex}
                herdIndex={herdIndex}
                removeFeed={remove}
              />
            ))}
          </Table.Body>
        </Table>
        <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1em' }}>
          <Button
            type='button'
            size='small'
            icon='plus'
            style={{ color: 'white' }}
            content={t('Add Feed')}
            onClick={() => {
              const id = getValues(`herdGroups[${herdIndex}].id`)
              const element = document.getElementById(id)
              if (element && element.classList?.contains(HERD_GROUP_ERROR_CLASS)) {
                element.classList.remove(HERD_GROUP_ERROR_CLASS)
              }
              append({
                id: null,
                cftFeedRegionId: null,
                dryMatterValue: null,
                freshWeightValue: null
              })
            }}
          />
        </div>
      </Segment>
    </>
  )
}
export default AvgFeeds